import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { FooterLayout } from "../Footer/FooterLayout";
import { ConfirmModalComponent } from "../../Components/ConfirmModal/ConfirmModalComponent";
import { ToastContainerComponent } from "../../Components/Toast/ToastContainerComponent";

@Component({
  selector: "app-public-layout",
  standalone: true,
  imports: [RouterOutlet, FooterLayout, ConfirmModalComponent, ToastContainerComponent],
  templateUrl: "./PublicShellLayout.html",
  styleUrl: "./PublicShellLayout.scss",
})
export class PublicShellLayout {}
